module.exports = __webpack_public_path__ + "static/media/cosecha.69d5eb04.mp4";